import React from 'react';

interface JsonLdProps {
  schema: Record<string, unknown>;
}

const JsonLd = ({ schema }: JsonLdProps): JSX.Element => {
  return <script type='application/ld+json'>{JSON.stringify(schema)}</script>;
};

export default JsonLd;
